import { render } from "./ElegirFormaDePago.vue?vue&type=template&id=15861b4b&scoped=true"
import script from "./ElegirFormaDePago.vue?vue&type=script&lang=js"
export * from "./ElegirFormaDePago.vue?vue&type=script&lang=js"

import "./ElegirFormaDePago.vue?vue&type=style&index=0&id=15861b4b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/FONSNTE/FONSNTE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15861b4b"]])

export default __exports__